import React from "react";

function ContentList({ children }) {
  return <div className="content-list">{children}</div>;
}

export default ContentList;
